export class ScreenSize {
  constructor(width, height) {
    this.width = width
    this.height = height
  }
}



// WEBPACK FOOTER //
// ./src/api/model/StatisticsData/ScreenSize.js